import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";

import { mapGetters } from "vuex";

import AddedFavouriteIcon from "@/assets/images/icons/favourite_ok.svg?inline";
import InterestingBtn from "../InterestingBtn";
import StreetPhoto from "./components/StreetPhoto";
import CheckMark from "@/assets/images/icons/check-inverse.svg?inline";

export default {
  name: "property",

  data() {
    return {
      // swiper: null,
      swiperSlides: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination.pr-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next.pr-next",
          prevEl: ".swiper-button-prev.pr-prev"
        }
      }
    };
  },

  props: ["property", "isUpdateSwiper"],

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    statusMarket() {
      return this.property.onMarket ? "On-Market" : "Off-Market";
    }
  },

  mounted: function() {
    this.$nextTick(() => {
      // TODO: If you check for> 1 instead of 0, then for a case with one picture it will produce a stub
      if (this.property.photos.length > 0) {
        this.swiperSlides = this.property.photos.slice(0, 5);
      }
    });
  },

  watch: {
    isUpdateSwiper() {
      if (this.swiper) {
        this.swiper.update();
      }
    }
  },

  methods: {
    currentProperty(property, type) {
      event.stopPropagation();
      this.$emit("hoveredProperty", property.id, type);
    },

    addressCompact(property) {
      if (property.onMarket)
        return property.fullAddress.replace(/\s+/g, '-').replace(/,/g, '').toLowerCase();
      else
        return `${property.likelihoodToSellDescription.replace(/\s+/g, '-').replace(/,/g, '').toLowerCase()}-${property.listPrice}`;
    },

    isOffMarketClaimed(property) {
      return property.status === 'Off-Market Claimed';
    },

    handleUpdatePropertyInteresting(interesting) {
      this.$emit("updatePropertyInteresting", {
        id: this.property.id,
        interesting: interesting
      });
    },

    handler: function(e) {
      e.preventDefault();
    }
  },

  components: {
    swiper,
    swiperSlide,
    AddedFavouriteIcon,
    InterestingBtn,
    StreetPhoto,
    CheckMark
  },

  directives: {
    swiper: directive
  }
};
